import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Modal } from 'semantic-ui-react';

// Global Types
import { AppState } from 'services/types';
import { HarvestEventUuid } from 'services/harvestEvents/types';

import {
    ADMIN,
    MANAGER,
    ASSISTANT_MANAGER
} from 'components/RoleGate/constants';
import RoleGate from '../../../../components/RoleGate';

// Actions
import { updateQueryString } from '../../../../services/router/actions';

// Workspaces
// @ts-ignore
import { ErrorBoundary } from '../../../../workspaces/redux-error-boundary';

// Components
// @ts-ignore
import ErrorBoundaryAlert from '../../../../components/ErrorBoundaryAlert';
import SeasonalEventForm from './components/SeasonalEventForm';
import FindOrCreateSeasonalEventForm from './components/FindOrCreateSeasonalEventForm';
// @ts-ignore
import SeasonalEventModalContentSuccess from './components/SeasonalEventModalContentSuccess';

// Workspaces
import { makeSelectQueryStringValue } from '../../../../workspaces/react-router-selectors';

import { selectEntityId } from './selectors';

interface ConnectedProps {
    harvestEventUuid?: HarvestEventUuid;
    seasonalEventModal?: 'created' | 'updated' | 'edit';
    defaultValues: Record<string, any>;
    entityId: ReturnType<typeof selectEntityId>;
}

interface DispatchProps {
    updateQueryString: Function;
}

type Props = ConnectedProps & DispatchProps;

export class SeasonalEventDialog extends React.PureComponent<Props> {
    get open(): boolean {
        const { seasonalEventModal } = this.props;
        return !!seasonalEventModal;
    }

    handleClose = (): void => {
        this.props.updateQueryString({
            seasonalEventModal: undefined,
            selectedEvent: undefined,
            selectedCurrentEntityId: undefined,
            newGroup: undefined,
            seasonalEventDefaultValues: undefined
        });
    };

    render(): React.ReactElement {
        const {
            seasonalEventModal,
            harvestEventUuid,
            defaultValues,
            entityId
        } = this.props;
        let Content;

        if (seasonalEventModal === 'created') {
            Content = <SeasonalEventModalContentSuccess title="Job Created" />;
        } else if (seasonalEventModal === 'updated') {
            Content = <SeasonalEventModalContentSuccess title="Job Updated" />;
        } else if (harvestEventUuid) {
            Content = (
                <SeasonalEventForm
                    onClose={this.handleClose}
                    harvestEventUuid={harvestEventUuid}
                    entityId={entityId}
                />
            );
        } else if (!defaultValues) {
            Content = (
                <FindOrCreateSeasonalEventForm onClose={this.handleClose} />
            );
        } else {
            Content = (
                <SeasonalEventForm
                    onClose={this.handleClose}
                    defaultValues={defaultValues}
                    entityId={defaultValues.entityId}
                />
            );
        }

        return (
            <RoleGate requiredRoles={[ADMIN, MANAGER, ASSISTANT_MANAGER]}>
                <Modal
                    open={this.open}
                    onClose={this.handleClose}
                    size="tiny"
                    centered={false}
                    closeIcon
                >
                    <ErrorBoundary
                        namespace="SeasonalEventDialog"
                        FallbackComponent={<ErrorBoundaryAlert />}
                    >
                        {Content}
                    </ErrorBoundary>
                </Modal>
            </RoleGate>
        );
    }
}

const mapStateToProps = createStructuredSelector<AppState, {}, ConnectedProps>({
    harvestEventUuid: makeSelectQueryStringValue('selectedEvent'),
    seasonalEventModal: makeSelectQueryStringValue('seasonalEventModal'),
    defaultValues: makeSelectQueryStringValue('seasonalEventDefaultValues'),
    entityId: selectEntityId
});

export default connect(mapStateToProps, { updateQueryString })(
    SeasonalEventDialog
);
